<template>
      <div id="header">
        <div class="container">
          <div id="logo" class="block">
            <div class="content">
              <a href="#"><img src="../../../assets/images/logo.png"></a>
            </div>
          </div> 
            
          <div id="slogan" class="block">
            <div class="content">
              <a href="#">Детская стоматология <span>и Ортодонтия</span></a>
            </div>
          </div> 
          
        <div id="cabinet" class="block authorized">
          <div class="content">
              
            <ul>
              <li class="first"><a href="#"><img :src=userPhotoUri.uri /></a></li>
              <li class="expanded"><a href="#">Администратор {{ userName }}</a>
                <ul>
                  <li><a href="#" @click="profile">Профиль</a></li>
                  <li><a href="#" @click="handleLogout">Выход</a></li>
                </ul>
              </li>
                
            </ul>
          </div>
        </div> 

          <div id="online" class="block">
            <div class="content">
              <a href="#" class="button">Запись на прием</a>
            </div>
          </div> 
          <div id="phone" class="block">
            <div class="content">
              <a class="mangophone" href="tel:+78122009571">+7 812 200-95-71</a>
            </div>
          </div>
        </div>
      </div>
  
</template>

<script>
  import connector from '@/utils/Connection';
  import { userPhotoUri } from '@/utils/helpers';
  //import { notify } from "@kyvg/vue3-notification";
  export default {
    data(){
      return {
        userName: this.$store.getters.getUserName,
        userPhotoUri: userPhotoUri,
      }
    },

    beforeMount() {
      this.userPhotoUri.uri = connector.entryPoint + `users/image?id=${this.$store.getters.getUserId}&key=${this.userPhotoUri.key}`;
    },


    methods: {
      async handleLogout() {
        await this.$store.commit('setUserData', null);
        await this.$store.commit('setUserId', null);
        await this.$store.commit('setUserIsAdmin', false);
        await connector.logout();
        this.$router.push('/login');
      },
      profile(){
        this.$router.push('/profile');
      }
    }
  }
</script>